import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { z } from "zod";

import RoleForm from "@/admin/components/settings/roles/RoleForm";
import { fetchRoleQueryOptions } from "@/admin/services/roles";
import Container from "@/components/containers/Container";
import { type ChildRouteContext } from "@/root";
import { throwIfHasNoPermission } from "@/utils/permissions";

export const Route = createFileRoute(
  "/admin/_panel/_settings/settings/roles/$id",
)({
  component: RouteComponent,
  parseParams: (params) => ({
    id: z.number().int().parse(Number(params.id)),
  }),
  beforeLoad: ({ context }) => {
    throwIfHasNoPermission(context.user, "core.role.update");

    return {
      title: () => context.t("Roles", { ns: "core.admin" }),
    } satisfies ChildRouteContext;
  },
  loader: (opts) =>
    opts.context.queryClient.ensureQueryData(
      fetchRoleQueryOptions(opts.params.id),
    ),
  stringifyParams: ({ id }) => ({ id: `${id}` }),
});

function RouteComponent() {
  const { id } = Route.useParams();
  const { t } = useTranslation("core.shared");

  return (
    <Container title={t("Create Role")}>
      <RoleForm id={id} />
    </Container>
  );
}
